import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./authContext";
import ProtectedRoute from "./ProtectedRoute";
import RequirePerm from "./RequirePerm";
import Login from "./Login";
import Onboarding from "./Onboarding";
import Home from "./Home";
import NewCar from "./NewCar";
import Setting from "./Setting";
import Report from "./Report";
import InvitePage from "./InvitePage";
import ResetPassword from "./ResetPassword";

function App() {
    return (
        <AuthProvider>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="login" element={<Login />} />
                <Route path="onboarding" element={<Onboarding />} />
                <Route path="invite/:token" element={<InvitePage />} />
                <Route path="reset-password" element={<ResetPassword />} />
                <Route path="home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="newcar" element={<ProtectedRoute><RequirePerm perm="is_newcar" label="เพิ่ม/แก้ไขรถ"><NewCar /></RequirePerm></ProtectedRoute>} />
                <Route path="newcar/:carId" element={<ProtectedRoute><RequirePerm perm="is_newcar" label="เพิ่ม/แก้ไขรถ"><NewCar /></RequirePerm></ProtectedRoute>} />
                <Route path="setting" element={<ProtectedRoute><RequirePerm perm="is_setting" label="ตั้งค่า"><Setting /></RequirePerm></ProtectedRoute>} />
                <Route path="report" element={<ProtectedRoute><RequirePerm perm="is_report" label="ดูรายงาน"><Report /></RequirePerm></ProtectedRoute>} />
            </Routes>
        </AuthProvider>
    );
}

export default App;
